import { featureIds } from '../schema/featureIds.js';
import { productIds } from '../schema/productIds.js';

const upgradableProductIds = [productIds('production').professional, productIds('development').professional];
const upgradableFeatureIds = [featureIds.tasks, featureIds.logRetention, featureIds.runnerSize];

/**
 * Says whether a subscription can buy an add-on from the billing screen: only an active,
 * non-legacy professional plan, and only tasks, log retention or runner size. The billing
 * screen shows its upgrade buttons and the upgrade route accepts a request on the same rule.
 */
export const getIsAddOnUpgradable = ({ isActive, isLegacy, productId, featureId }) => {
  return isActive === true && !isLegacy && upgradableProductIds.includes(productId) && upgradableFeatureIds.includes(featureId);
};
